/* @flow */

import type {
    FullWidget,
    ComponentState,
    GetComponentState
} from 'reactive-di-observable'

import type {
    Element
} from 'react'

import {Component} from 'react'
import {findDOMNode} from 'react-dom'

class ReactStateObserver<E, Props, State> {
    _component: Component<void, Props, State>;

    constructor(component: Component<void, Props, State>) {
        this._component = component
    }

    next<S>(state: S): void {
        this._component.setState(state)
    }

    error(error: E): void {
        throw error
    }

    complete(): void {
    }
}

export default function createReactWidget<State, Props, El: Element<*>>(
    getState: GetComponentState<Props, State, El>,
    displayName: string
): mixed {
    return class WrappedWidget extends Component<void, Props, any> {
        static displayName: string = displayName;
        state: State;
        props: Props;

        _subscription: ?Subscription;
        _widget: FullWidget<Props, State, El>;
        _observable: ?Observable<State, Error>;

        componentWillMount(): void {
            const {state, observable, Widget}: ComponentState<Props, State, El> = getState()
            this._observable = observable
            this._widget = new Widget(state)
            this._widget.props = this.props
            this.setState(state)
        }

        componentWillReceiveProps(props: Props): void {
            this._widget.props = props
        }

        componentDidMount(): void {
            if (this._observable) {
                this._subscription = this._observable
                    .subscribe(new ReactStateObserver(this))
            }
            if (this._widget.onCreate) {
                (this._widget: any).onCreate(this.props, this.state, findDOMNode(this))
            }
        }

        componentDidUpdate(): void {
            if (this._widget.onUpdate) {
                (this._widget: any).onUpdate(this.props, this.state, findDOMNode(this))
            }
        }

        componentWillUnmount(): void {
            if (this._subscription) {
                this._subscription.unsubscribe()
                this._subscription = null
            }
            if (this._widget.onRemove) {
                (this._widget: any).onRemove(this.props, this.state, findDOMNode(this))
            }
        }

        render(): El {
            this._widget.state = this.state
            return this._widget.render(this.props, this.state)
        }
    }
}
